const namespace = require('./namespace.js');
const fixedTitleBar = require('../components/fixedTitleBar/fixedTitleBar.js');
const fixedNavObserver = require('../components/fixedNavObserver/fixedNavObserver.js');
const layoutJumpLinks = require('../components/layoutJumpLinks/layoutJumpLinks.js');
const phoneLocalizer = require('../components/phoneLocalizer/phoneLocalizer.js');
const accordions = require("../components/accordion/accordion.js");
const tabExtensions = require("../components/tabExtensions/tabExtensions.js");
const heroSlider = require('../components/heroSlider/heroSlider.js');
const simplePopup = require('../components/simplePopup/simplePopup.js');
const siteSearch = require('../components/siteSearch/siteSearch.js');
const conversionTracking = require('../components/conversionTracking/conversionTracking.js');
const formSubmissionHandler = require('../components/formSubmissionHandler/formSubmissionHandler.js');
const asyncForms = require('../components/asyncForms/asyncForms.js');
const favorites = require('../components/favorites/favorites.js');
const fancyBoxBySize = require('../components/fancyBoxBySize/fancyBoxBySize.js');
const countdownTimer = require('../components/countdownTimer/countdownTimer.js');

// Event Handlers
// new component architecture
function _registerEventHandlers() {

    document.addEventListener('fixed-nav-resize-observed', function (e) {
        // on height change, push body down, so the page does not slide up behind the fixed nav
        document.body.style.paddingTop = e.detail + 'px';
    });

    fixedNavObserver.initialize();

    // expose this module for legacy purposes
    window.configurePhoneNumbers = phoneLocalizer.applyLocalization;

    $(document).ready(function () {
        fixedTitleBar.initialize({ disabledContentTypes: ['tour', 'cruise'] });
        layoutJumpLinks.initialize({ disabledContentTypes: ['tour', 'cruise'] });

        // Setup components
        
        accordions.initialize();
        phoneLocalizer.applyLocalization();
        
        tabExtensions.initialize();
        heroSlider.initialize();

        // Initialize the predictive site search for desktop
        siteSearch.initialize('search_text');
        // Initialize the predictive site search for mobile
        siteSearch.initialize('mobile_search_text');
        simplePopup.initialize('.simple-popup-trigger');
        simplePopup.initialize('.form-popup-trigger', { maxWidth: 612, enableConversionTracking: true } );

        conversionTracking.initialize();

        formSubmissionHandler.initialize();
        asyncForms.initialize();

        // Favorites (aka: Wishlist)
        favorites.initializeFavoriteButtons('[data-like-toggle]');
        favorites.setFavoriteIcons();

        fancyBoxBySize.initialize(document);

        countdownTimer.initialize('.countdown-timer-item');

        //BACK TO TOP
        var bttThreshold = 1040;
        var $btt = $('a.backToTop');
        if ($btt && $btt.length > 0) {
            $(window).scroll(function () {
                var $this = $(this);
                if ($this.scrollTop() > bttThreshold && !$btt.hasClass('btt-in')) {
                    $btt.addClass('btt-in');
                } else if ($this.scrollTop() <= bttThreshold && $btt.hasClass('btt-in')) {
                    $btt.removeClass('btt-in');
                }
            });
        }
    });
}
_registerEventHandlers();

// old non-architecture with just a bunch of JS swimming together
; (function ($) {

    $(document).ready(function () {
        setupVacationFinder();
        //setupTopNav();
        //setupMobileNav();
        //topStripScroll();
        formatGridFeatureLinks();

        // configureSequenceSliders
        configureFlashSaleSlider();

        // reflect live chat to each live chat reflection destination
        reflectLiveChat();

        // setup dropdowns with custom styling
        setupSelectBoxes('.chosen-select');
        setupSelectBoxes('.home-slider-destination-select');
        setupSelectBoxes('.footer-destination-select', '80%');
        setupSelectBoxes('.vacation-finder-select', '97%');
        setupSelectBoxes('.popup-select', '100%');
        //setupSelectBoxes('.request-quote-select', '32%');

        // fix slimmage/slimsy on bootstrap nav-tabs
        $('.nav.nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            window.slimmage.checkResponsiveImages();
        });

        // make sure to trim any trailing commas to prevent jQuery errors when no sorting options are present
        var pageHash = location.hash ? location.hash.replace(/,$/, "") : '';
        if (pageHash !== '') {
            var $hashEl = $(pageHash);
            if ($hashEl && $hashEl.length >= 1) {

                $('html,body').animate({
                    scrollTop: $(location.hash).offset().top
                }, 'slow');
            }
        }

        $('#SEOReadMore').on('click', function () {

            $(".summaryContent").toggleClass("limitSize");

            //$(".summaryContent").toggle(function () {
            //    $(this).animate({ height: 270 }, auto);
            //});
        });

        // should show any getorigin-inv contour fields when GETOrigin cookie is not set. Hide them otherwise
        var originFields = $('.getorigin-inv');
        var originCookie = $.cookie('GETOrigin');
        if (!originCookie || originCookie.indexOf('Source') !== 0) {
            originFields.show();
        } else {
            originFields.hide();
        }

        advancedSearchCollapse();
        bindCookieWarningHide();
    });

    function bindCookieWarningHide() {
        var $cookieWarn = $('.cookie-warn');
        var cookieWarnCookie = $.cookie("GETCookiePolicy");
        if (cookieWarnCookie == 1) {
            return;
        } else {
            var delayTime = parseInt($cookieWarn.attr("popup-delay"));
            window.setTimeout(function () {
                $cookieWarn.show();
            }, delayTime);
        }

        $(".close-cookie-warn").click(function () {
            hideCookieWarning();
        });
    }
    function hideCookieWarning() {
        //$(".topStrip").addClass("hide-cookie-warn");
        $(".cookie-warn").hide();
        $("header").css("margin-top", "0");
        $(".topStrip").css("margin-top", "0");
        $.cookie("GETCookiePolicy", 1, { domain: 'getours.com', path: '/', expires: 1 * 356 }); //the expires math is there for extensibility and clarity
    }

    function configureFlashSaleSlider() {
        var $flashSaleSequence = $('.flash-sale-sequence');
        if ($flashSaleSequence.length > 0) {
            $.each($flashSaleSequence, function (fidx, flashSequenceEl) {
                var $flashSequence = $(flashSequenceEl);
                var hasMultipleSlides = $flashSequence.find('.seq-item').length > 1;
                if (hasMultipleSlides) {
                    sequence(flashSequenceEl, {
                        autoPlay: true,
                        autoPlayInterval: 5000,
                        pagination: '.zzzClassThatDoesntExistzzz',  //"pagination: false" causes js errors. Must pass selector to non-existent element
                        nextButton: false,
                        prevButton: false,
                        animateCanvas: false
                    });
                }
            });
        }
    }

    function setupSelectBoxes(selector, widthAttr) {
        var $chosenSelect = $(selector);
        var $chosenForm = $chosenSelect.closest('form');
        $chosenForm.find('select[data-val-required]').prop('required', true);
        $chosenSelect.change(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                $this.removeClass('input-validation-error');
                $this.siblings('.field-validation-error')
                    .removeClass('field-validation-error')
                    .addClass('field-validation-valid')
                    .empty();
            }
        });

        if (widthAttr) {
            $chosenSelect.chosen({
                disable_search: true,
                width: widthAttr
            });
        } else {
            $chosenSelect.chosen({
                disable_search: true
            });
        }

        var chosenContainers = $chosenSelect.siblings('.chosen-container');
        chosenContainers.each(function () {
            var $this = $(this);
            var chosenDrop = $this.find('.chosen-drop');
            var chosenSingle = $this.find('.chosen-single');
            $this.on('mouseover', function () {
                if (isOnBottomHalfOfPage(chosenSingle)) {
                    if (chosenDrop.css('top') !== 'auto') {
                        chosenDrop.css('top', 'auto');
                        chosenDrop.css('bottom', '100%');
                        chosenDrop.css('border-radius', '4px 4px 0 0');
                    }
                } else {
                    if (chosenDrop.css('bottom') !== 'auto') {
                        chosenDrop.css('bottom', 'auto');
                        chosenDrop.css('top', '100%');
                        chosenDrop.css('border-radius', '0 0 4px 4px');
                    }
                }
            });
        });
    }


    function isOnBottomHalfOfPage(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var docViewMiddle = (docViewTop + docViewBottom) / 2;

        var elemTop = elem.offset().top;

        return elemTop >= docViewMiddle;
    }

    // Pull the live chat from the header and copy it to each reflection
    function reflectLiveChat() {
        var liveChatDivs = $('.liveChat');
        if (liveChatDivs.length <= 0) {
            return;
        }

        var liveChatImg = liveChatDivs.find('.lpStaticButtonTR img');
        if (liveChatImg.length != 1) {
            return;
        }

        var liveChatReflections = $('.liveChatReflection');
        $.each(liveChatReflections, function (idx, val) {
            var $this = $(this);
            $this.append('<a href="#"><img src="' + liveChatImg.attr('src') + '"></img></a>');

            $this.on('click', function (e) {
                liveChatImg.click();
            });
        });
    }

    function setupVacationFinder() {
        var vacationFinder = $('.vacationFinder');
        var vacationFinderForm = $('.vacationFinderForm');

        vacationFinder.click(function (e) {
            e.preventDefault();
            vacationFinder.toggleClass('open');
            vacationFinderForm.toggleClass('open');
        });
    }

    function formatGridFeatureLinks() {
        var $featureLinkWrapper = $('.feature-links');
        if ($featureLinkWrapper.length > 0) {
            var $featureLinks = $featureLinkWrapper.children('li');
            if ($featureLinks.length > 0) {
                // Fix dividers. Remove dividers when line breaks
                trimFeatureLinkDividers($featureLinks);
                $(window).on('resize', function () {
                    trimFeatureLinkDividers($featureLinks);
                });
            }
        }
    }

    // use the y-offset of the feature links to determine if they have wrapped or not
    // use that information to add/remove the "no-divider" class and fix the divider problem
    function trimFeatureLinkDividers($featureLinks) {
        for (var i = 1; i < $featureLinks.length; i++) {
            var $previousFeatureLink = $($featureLinks[i - 1]);
            var $currentFeatureLink = $($featureLinks[i]);
            if ($previousFeatureLink.hasClass('no-divider')) {
                if (Math.round($previousFeatureLink.offset().top) === Math.round($currentFeatureLink.offset().top)) {
                    $previousFeatureLink.removeClass('no-divider');
                }
            } else {
                if (Math.round($previousFeatureLink.offset().top) !== Math.round($currentFeatureLink.offset().top)) {
                    $previousFeatureLink.addClass('no-divider');
                }
            }
        }
    }

    function advancedSearchCollapse() {
        $(".advancedSearchFiltersToggle").click(function () {
            $this = $(this);
            $icon = $this.find("i");
            $advancedFilters = $('.' + $this.attr('data-target'));
            $advancedFilters.each(function (i, section) {
                var $section = $(section);
                if ($section.hasClass("collapse")) {
                    $section.addClass("collapse.show");
                    $section.removeClass("collapse");

                    $icon.addClass("fa-minus");
                    $icon.removeClass("fa-plus");
                } else {
                    $section.removeClass("collapse.show");
                    $section.addClass("collapse");

                    $icon.removeClass("fa-minus");
                    $icon.addClass("fa-plus");
                }
            });
        });
    }

})(jQuery);